export default __webpack_public_path__ + "static/nl-8309f740b2200415878dae036846afd1.svg";